/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable import/prefer-default-export */
import axios, { AxiosRequestConfig } from 'axios';
import { BASE_URL } from '../../config/config';

axios.defaults.baseURL = BASE_URL; // the prefix of the URL
axios.defaults.headers.get.Accept = 'application/json'; // default header for all get request

const http = <T>({ url, method = 'GET', data, params }: AxiosRequestConfig): Promise<T> =>
  axios(url as string, {
    method,
    data: data || undefined,
    params
  }).then(({ data: response }) => response);

export const getLiveMatch = <T>(matchId: string, language: string, sportType: string) =>
  http<T>({
    url: `/${sportType.toLocaleLowerCase()}/match/${matchId}${
      language ? `?language=${language}` : ''
    }`
  });
